import React from "react";
import {  useSelector } from "react-redux";
import RenderHtmlFormattedText from "../../../HtmlElements/RenderHtmlFormattedText";

const decodeHtml = (htmlString) => {
  const parser = new DOMParser();
  const decodedString = parser.parseFromString(htmlString, "text/html").body
    .textContent;
  return decodedString;
};

export default function CustomTabs({content}) {
  // const { globalValue } = useSelector((state) => state?.globalReducer);

  // const { dynamicTabsData } = useSelector((state) => state?.dynamicTabsReducer);

  // const contentData = dynamicTabsData.find(
  //   (item) => item?.tab_slug == globalValue
  // );

  const decodedHtml = decodeHtml(content);

  return (
    <div style={{ padding: "5vh" }}>
      <div
        style={{
          borderBottom: "1px solid #E2E8F0",
          backgroundColor: " #fff",
          border: "solid 0.1rem  #E4E4E7",
          borderRadius: "1vh",
          padding: "5vh",
          display:"flex",
          justifyContent:"center",
          alignItems:"center"
        }}
      >
        <RenderHtmlFormattedText htmlContent={decodedHtml} />
      </div>
    </div>
  );
}
